import { ConfigProvider, Pagination, PaginationProps, Tabs } from 'antd';
import { useEffect, useMemo, useState } from 'react';
import '../../../styles.scss';

import { EditOutlined, EyeOutlined, FileAddOutlined, SettingOutlined } from '@ant-design/icons';
import { ColDef } from 'ag-grid-community';
import { AgGridReact } from 'ag-grid-react';
import viVN from "antd/locale/vi_VN";
import { useSelector } from 'react-redux';
import { FieldsUpdate, getInfoRepairAppointment, getInfoServiceSalesCare, getListCustomerCareAndService, getListFieldsByCustomer, ICustomer, InfoRepairAppointment, InfoServiceSalesCare, ListField, updateFieldUser } from '../../../../../api/Customer_V2/customerApi_V2';
import { NodataTable } from '../../../../../components/NoDataTable';
import useDebounce from '../../../../../hook/useDebounce';
import useLoading from '../../../../../hook/useLoading';
import useThrottle from '../../../../../hook/useThrottle';
import useToast from '../../../../../hook/useToast';
import { FIELDTYPE, NO_VIEW, SERVICETYPE } from '../../../../../services/data';
import { formatNumber } from '../../../../../services/mixin';
import { selectorCategoryCarIds } from '../../../../../store/slices/categoryCarSlice';
import { selectorInfoUser } from '../../../../../store/slices/infoUserSlice';
import { CustomLoadingOverlayTable, dataPagination, flattenFields } from '../../../../../until';
import { IPagination } from '../../../../Customers/CustomerGroup/Component/AddGroup/AddNewGroup';
import { ColumnKey } from '../../../../Customers/Tabs/CarListCardClone';
import { FlattenedField } from '../../../../CustomersV2/indexV2';
import ServiceRecordFeilds from '../../ServiceRecords/Components/ServiceRecordFeilds';
import { generateColumnsFromCodesAgGridReactRecordCar } from '../../ServiceRecords/ContactInformation';
import ModalSalesAndServiceAdd from '../TabInvoiceHistory/Components/ModalSalesAndServiceAdd';
import ModalSalesAndServiceDetail from '../TabInvoiceHistory/Components/ModalSalesAndServiceDetail';
import ModalSalesAndServiceScheduleARepairAdd from '../TabInvoiceHistory/Components/ModalSalesAndServiceScheduleARepairAdd';
import ModalSalesAndServiceScheduleARepairUpdate from '../TabInvoiceHistory/Components/ModalSalesAndServiceScheduleARepairUpdate';
import ModalSalesAndServiceUpdate from '../TabInvoiceHistory/Components/ModalSalesAndServiceUpdate';
import TabSalesAndServiceTabDetail from './Components/TabSalesAndServiceTabDetail';

type PaginationKey = "info";
interface IDataFilterActive {
  info: FlattenedField[];
}

interface IDataFilterNoActive {
  info: ListField[];
}

const EMPTY_GROUP = {
  info: [],
};

enum TYPESERVICEMODAL {
  SCHEDULEAREPAIR = 0, // SỬA CHỮA
  REGISTERFORWARRANTY = 1, // BẢO HÀNH
  SALESANDSERVICE = 2, // DỊCH VỤ
}


interface Props {
  loadingTable: boolean
  isModalSalesAndServiceDetail: boolean
  isModalSalesAndServiceScheduleARepairAdd: boolean
  isModalSalesAndServiceScheduleARepairUpdate: boolean
  isModalSalesAndServiceUpdate: boolean
  isModalSalesAndServiceAdd: boolean

  dataFieldsActive: FlattenedField[]
  idCustomer?: number
  data: ICustomer[]
  pagination: IPagination

  onPaginationChange: (page: number, pageSize: number) => void
  setIsModalSalesAndServiceDetail: (e: boolean) => void
  setIsModalSalesAndServiceScheduleARepairAdd: (e: boolean) => void
  setIsModalSalesAndServiceScheduleARepairUpdate: (e: boolean) => void
  setIsModalSalesAndServiceUpdate: (e: boolean) => void
  setIsModalSalesAndServiceAdd: (e: boolean) => void

  resultFormSubmitSalesAndService?: (iSsuccess: boolean, message?: string) => void
}

const TabSalesAndService: React.FC<Props> = ({
  loadingTable,
  isModalSalesAndServiceDetail,
  isModalSalesAndServiceScheduleARepairAdd,
  isModalSalesAndServiceScheduleARepairUpdate,
  isModalSalesAndServiceAdd,
  isModalSalesAndServiceUpdate,

  dataFieldsActive, pagination,
  idCustomer, data,

  setIsModalSalesAndServiceDetail,
  setIsModalSalesAndServiceScheduleARepairAdd,
  setIsModalSalesAndServiceScheduleARepairUpdate,
  setIsModalSalesAndServiceAdd,
  setIsModalSalesAndServiceUpdate,

  onPaginationChange, resultFormSubmitSalesAndService
}) => {
  useEffect(() => {
    gListFieldsActive()
  }, [])


  const pushLoading = useLoading()
  const pushToast = useToast();
  const permittedCategoryCarIds = useSelector(selectorCategoryCarIds)

  const { id, unitTemp } = useSelector(selectorInfoUser) // đợn vị dc chọn

  const [isSettingShow, setSettingShow] = useState(false)
  const [loadingTableDetail, setLoadingTableDetail] = useState(false)

  const [activeTab, setActiveTab] = useState<PaginationKey>("info");
  const [dataFieldsSalesAndServiceActive, setDataFieldsSalesAndServiceActive] = useState<IDataFilterActive>(EMPTY_GROUP);
  const [dataFieldsSalesAndServiceNoActive, setDataFieldsSalesAndServiceNoActive] = useState<IDataFilterNoActive>(EMPTY_GROUP);
  const [columnsMapShow, setColumnsMapShow] = useState<ColumnKey[]>([]);
  const [paginationMap, setPaginationMap] = useState<Record<PaginationKey, IPagination>>({
    info: { current: 1, pageSize: 10, total: 0 },
  });
  const [loadedTabs, setLoadedTabs] = useState<Record<PaginationKey, boolean>>({
    info: false,
  });

  const [selectId, setSelectId] = useState<number>()
  const [infoSalesAndService, setInfoSalesAndService] = useState<ICustomer[]>([]);

  const [infoModalSalesAndService, setInfoModalSalesAndService] = useState<InfoServiceSalesCare>();
  const [infoRepairAppointment, setInfoRepairAppointment] = useState<InfoRepairAppointment>();

  //#region Cấu hình cột


  const actionColumn: ColDef = {
    headerName: 'Hành động',
    field: 'action',
    colId: 'action',
    width: 180,
    resizable: false,
    suppressMovable: true,
    lockPosition: 'left',
    headerComponentParams: {
      template: '<span class="w-full flex items-center justify-center">Hành động</span>'
    },
    cellRenderer: (params: any) => {
      const { id, type } = params.data
      return (
        <div className='d-flex gap-2 justify-center align-center  h-full px-1'>
          <EyeOutlined
            className='text-sm border-D9D9D9 p-5-px bg-white rounded-2 cursor-pointer'
            onClick={(e) => {
              e.stopPropagation(); // 🔴 chặn click lan lên row
              const currentId = params.data?.id;
              if (!currentId) {
                pushToast("không tồn tại id!", 'error')
                return
              }
              if (currentId === selectId) {
                params.node.setSelected(false); // ❌ bỏ chọn
                setSelectId(undefined);         // reset
                return;
              }

              params.node.setSelected(true);    // ✅ chọn mới
              setSelectId(currentId);
              console.log(currentId)
            }}
          />
          <EditOutlined
            className={`text-sm border-D9D9D9 p-5-px bg-white rounded-2 cursor-pointer `}
            onClick={() => handleEdit(id, type)}
          />
          {type === SERVICETYPE.SALEANDSERVICE &&
            <FileAddOutlined
              className={`text-sm border-D9D9D9 p-5-px bg-white rounded-2 cursor-pointer `}
              onClick={() => handleEdit(id, type, true)}
            />

          }
        </div>

      )
    },
  }

  const memoizedColumnDefs = useMemo(() => {
    return generateColumnsFromCodesAgGridReactRecordCar(
      columnsMapShow,
      dataFieldsActive,
      actionColumn, // actionColumn
      undefined, // onToggleStatus
      { setDataFilterList: () => { } }, // headerActions
      undefined, // listFilterIcon
      undefined, // dataFilterList
      idCustomer, // customerId
      ["contact_name"] // listFieldCodeLink
    );

  }, [columnsMapShow, dataFieldsActive, selectId]);

  const tableData = useMemo(() => {
    return data.map((item) => {
      const fieldValues = item.fields.reduce((acc: Record<string, any>, field) => {
        acc[field.fieldCode] = field.view === false ? NO_VIEW : field.value;
        return acc;
      }, {});

      return {
        ...item,
        key: item.id.toString(),
        ...fieldValues
      };
    });
  }, [data]);

  useEffect(() => {
    const codes = dataFieldsActive.map((f) => f.fieldCode);
    setColumnsMapShow(codes);
  }, [dataFieldsActive]);
  //#endregion

  const gListFieldsActive = async () => {
    const [salesAndServiceTabDetailRes] =
      await Promise.all([
        getListFieldsByCustomer(FIELDTYPE.SalesAndServiceDetail, 1),
      ]);
    const flattenedFieldsContactInformation = flattenFields(salesAndServiceTabDetailRes?.data ?? []);

    setDataFieldsSalesAndServiceActive({
      info: flattenedFieldsContactInformation,

    });

    gListFieldsNotActive();
  };

  const gListFieldsNotActive = async () => {
    const [salesAndServiceTabDetailNoActiveRes] =
      await Promise.all([
        getListFieldsByCustomer(FIELDTYPE.SalesAndServiceDetail, 0),
      ]);

    setDataFieldsSalesAndServiceNoActive({
      info: salesAndServiceTabDetailNoActiveRes?.data ?? [],
    })
  };

  const gListDetail = useDebounce(async (pageCurent: number = 1, pageSize: number = 10) => {

    if (!idCustomer || !selectId) {
      setInfoSalesAndService([]);
      return;
    }
    setLoadingTableDetail(true)
    const result = await getListCustomerCareAndService(
      idCustomer, unitTemp, permittedCategoryCarIds,
      selectId, pageSize, pageCurent
    )
    if (result?.status) {
      setInfoSalesAndService(result.data)
      setPaginationMap(prev => ({
        ...prev,
        info: {
          current: pageCurent,
          pageSize,
          total: result.total,
        },
      }));
    } else {
      pushToast(result?.message, "warning")
    }
    // 🔥 QUAN TRỌNG
    setLoadedTabs(prev => ({
      ...prev,
      info: true,
    }));
    setLoadingTableDetail(false)
  }, 1000)


  const onSaveVisibleFields = useThrottle(async (dataFilterActive: FlattenedField[], dataFilterNoActive: ListField[]) => {
    let result: any;
    const activeFields: FieldsUpdate[] = dataFilterActive.map(item => ({
      fieldId: item.id,
      isActive: 1, // hoặc true tùy bạn muốn mặc định là gì
    }));
    const allFieldsDefaultInactive: FieldsUpdate[] = dataFilterNoActive.flatMap(group =>
      group.fields.map(field => ({
        fieldId: field.id,
        isActive: 0,
      }))
    );
    const listActiveFields = activeFields.concat(allFieldsDefaultInactive)

    switch (activeTab) {

      case 'info': {
        result = await updateFieldUser(id, FIELDTYPE.SalesAndServiceDetail, undefined, listActiveFields)
        break;
      }
      default:
        break;
    }

    if (result?.status) {
      pushToast(result?.message, "success")
      setSettingShow(false)

      if (dataFilterActive && dataFilterNoActive) {
        setDataFieldsSalesAndServiceActive(prev => ({
          ...prev,
          [activeTab]: dataFilterActive ?? [],
        }));

        setDataFieldsSalesAndServiceNoActive(prev => ({
          ...prev,
          [activeTab]: dataFilterNoActive ?? [],
        }));
      }

    } else {
      pushToast(result?.message, "warning")
    }
  }, 2000)

  const onPaginationChangeTab: PaginationProps['onChange'] = (pageNumber, pageSize) => {
    switch (activeTab) {
      case "info": {
        gListDetail(pageNumber, pageSize)
        break;
      }

      default:
        break;
    }
  }

  //#region Modal

  const handleEdit = async (id: number, type: SERVICETYPE, detail = false) => {
    if (!id || (type === null || type === undefined)) {
      pushToast("Id và loại dịch vụ không được bỏ trống!", 'error')
      return
    }
    switch (type) {
      case SERVICETYPE.SALEANDSERVICE: {
        pushLoading(true)
        const result = await getInfoServiceSalesCare(id)
        if (result?.status) {
          setInfoModalSalesAndService(result.data)
          if (detail) {
            setIsModalSalesAndServiceDetail(true)
          } else {
            setIsModalSalesAndServiceUpdate(true)
          }
        } else {
          pushToast(result?.message, "warning")
        }
        pushLoading(false)
        break;
      }
      case SERVICETYPE.SCHEDULEAREPAIR: {
        pushLoading(true)
        const result = await getInfoRepairAppointment(id)
        if (result?.status) {
          setInfoRepairAppointment(result.data)
          setIsModalSalesAndServiceScheduleARepairUpdate(true)
        } else {
          pushToast(result?.message, "warning")
        }
        pushLoading(false)
        break;
      }
      default:
        break;
    }
  }
  //#endregion 

  useEffect(() => {

    if (!selectId) return;

    // 1️⃣ RESET
    setInfoSalesAndService([]);

    setLoadedTabs({
      info: false,
    });

    setPaginationMap({
      info: { current: 1, pageSize: 10, total: 0 },

    });

    // 2️⃣ GỌI API ĐÚNG TAB
    switch (activeTab) {
      case "info":
        gListDetail();
        break;
      default:
        break
    }
  }, [selectId]);

  useEffect(() => {
    if (!selectId) return;

    switch (activeTab) {
      case "info":
        if (!loadedTabs.info) gListDetail();
        break;
      default:
        break
    }
  }, [activeTab]);
  return (
    <>

      <ModalSalesAndServiceScheduleARepairAdd
        isOpen={isModalSalesAndServiceScheduleARepairAdd}
        idCustomer={idCustomer}
        resultFormSubmit={resultFormSubmitSalesAndService}
        closeModal={setIsModalSalesAndServiceScheduleARepairAdd}
      />

      <ModalSalesAndServiceScheduleARepairUpdate
        isOpen={isModalSalesAndServiceScheduleARepairUpdate}
        idCustomer={idCustomer}
        infoRepairAppointment={infoRepairAppointment}

        resultFormSubmit={resultFormSubmitSalesAndService}
        closeModal={setIsModalSalesAndServiceScheduleARepairUpdate}
      />


      <ModalSalesAndServiceAdd
        isOpen={isModalSalesAndServiceAdd}
        idCustomer={idCustomer}
        resultFormSubmit={resultFormSubmitSalesAndService}
        closeModal={setIsModalSalesAndServiceAdd}
      />
      <ModalSalesAndServiceDetail
        isOpen={isModalSalesAndServiceDetail}
        idCustomer={idCustomer}
        closeModal={setIsModalSalesAndServiceDetail}

        infoModalSalesAndService={infoModalSalesAndService}
      />
      <ModalSalesAndServiceUpdate
        isOpen={isModalSalesAndServiceUpdate}
        idCustomer={idCustomer}
        infoModalSalesAndService={infoModalSalesAndService}

        resultFormSubmit={resultFormSubmitSalesAndService}
        closeModal={setIsModalSalesAndServiceUpdate}
      />

      {
        isSettingShow ?
          <ServiceRecordFeilds
            isSettingShow={isSettingShow}
            type={0}
            dataFilterActive={dataFieldsSalesAndServiceActive[activeTab]}
            dataFilterNoActive={dataFieldsSalesAndServiceNoActive[activeTab]}

            onSaveVisibleFields={onSaveVisibleFields}
            onClose={() => setSettingShow(false)}
          /> :
          null
      }
      <div className="custom-page-css w-full flex flex-col items-center justify-between gap-3 ">
        <div className="custom-page-css w-full flex flex-col items-center justify-between gap-3 ">
          <div className="ag-theme-alpine custom-table-ag custom-css-table"
            style={{ width: '100%', height: tableData.length === 0 ? 250 : tableData.length < 10 ? tableData.length * 65 + 65 : 650 }}
          >
            <AgGridReact
              className="my-auto-height-grid"
              getRowStyle={(params: any) => ({
                backgroundColor: params?.rowIndex % 2 ? '#f7f9fc' : '#ffffff',
              })}
              rowData={tableData}
              columnDefs={memoizedColumnDefs}
              rowHeight={55}
              overlayNoRowsTemplate={NodataTable}
              loading={loadingTable}
              loadingOverlayComponent={CustomLoadingOverlayTable}
              // onGridReady={(params) => {
              //   params.api.sizeColumnsToFit();
              // }}

              /* Selection – CHỈ CHO PHÉP SELECT BẰNG CODE */
              rowSelection="single"
              suppressRowClickSelection={true}

              /* Performance */
              suppressColumnVirtualisation={true}
              suppressRowVirtualisation={false}
              enableCellTextSelection={true}
              ensureDomOrder={true}
              debounceVerticalScrollbar={true}
              suppressScrollOnNewData={true}
              suppressDragLeaveHidesColumns={true}

              /* Scroll */
              rowBuffer={20}
              maxBlocksInCache={10}
              infiniteInitialRowCount={1000}
            />
          </div>
          <ConfigProvider
            locale={viVN}
          >
            <div className="pagination-block">
              <Pagination
                showSizeChanger
                current={pagination.current}
                pageSize={pagination.pageSize}
                total={pagination.total}
                itemRender={(page, type, originalElement) => {
                  // Chỉ custom khi là nút số trang
                  if (type === 'page') {
                    return <span>{formatNumber(page)}</span>;
                  }
                  // prev / next / jump-prev / jump-next giữ nguyên
                  return originalElement;
                }}
                showTotal={() =>
                  `Tổng cộng ${dataPagination(
                    pagination.total,
                    pagination.pageSize,
                    pagination.current
                  ).totalPage} trang`
                }
                className="rs-pagination"
                onChange={onPaginationChange}
              />
            </div>
          </ConfigProvider>

        </div>

        {/* {
          selectId ? ( */}
        <div
          className="custom-page-css w-full flex items-center justify-between gap-3 pt-3 relative"
        >
          <Tabs
            className='w-full'
            activeKey={activeTab}
            items={[
              {
                key: 'info',
                label: <span className='custom-page-css font-light text-lg'>Chi tiết</span>,
                children:
                  <TabSalesAndServiceTabDetail
                    loadingTableDetail={loadingTableDetail}
                    dataFieldsActive={dataFieldsSalesAndServiceActive.info}
                    pagination={paginationMap.info}
                    data={infoSalesAndService}

                    onPaginationChange={onPaginationChange}

                  />
                ,
              },
            ]}
          />
          <div className="custom-page-css absolute top-4 right-0">
            <div className='settingCol'>
              <div className='ctr-col-setting'
                onClick={() => setSettingShow(true)}
              >
                <SettingOutlined />
              </div>
            </div>
          </div>
        </div>

      </div>
    </>
  )
}
export default TabSalesAndService